import useFetchApps from "utils/useFetchApps"
import { fetchAll } from "queries"
import usePullToRefresh from "utils/usePullToRefresh"
import useFiltersStore from "stores/filters"
import FeedList from "./FeedList"

const AppsAndGames = () => {
  const price = useFiltersStore((state) => state.price)
  const {
    data: apps,
    isFetchingNextPage,
    fetchNextPage,
    refetch,
  } = useFetchApps({
    queryFn: ({ pageParam }) => fetchAll({ price, pageParam }),
    queryKey: [price ? "getAll" + price : "getAll"],
  })
  usePullToRefresh({ refetch, element: "#all-apps-card", page: "allApps" })

  return (
    <div id="all-apps-card">
      <FeedList
        apps={apps}
        isPending={isFetchingNextPage}
        endReached={fetchNextPage}
      />
    </div>
  )
}
export default AppsAndGames
